import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../template/_metronic/assets/ts/_utils'
import {WithChildren} from '../../template/_metronic/helpers'
import UploadFilePage from '../modules/apps/upload-file/UploadFilePage'
import ScheduledPage from '../modules/apps/scheduled/ScheduledPage'
import HistoryPage from '../modules/apps/history/HistoryPage'
import {ErrorBatchesPage} from '../modules/apps/error-batches/ErrorBatchesPage'
import {MasterLayout} from '../../helpers/layout/MasterLayout'
import UsersPage from '../modules/apps/user-management/UsersPage'
import {ProfilePage} from '../modules/apps/profile/ProfilePage'

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to upload file after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/upload-file' />} />
        <Route path='upload-file/*' element={<UploadFilePage />} />
        <Route path='errors/*' element={<ErrorBatchesPage />} />
        <Route path='scheduled/*' element={<ScheduledPage />} />
        <Route path='history/*' element={<HistoryPage />} />
        <Route path='user-managment/*' element={<UsersPage />} />
        <Route path='profile/*' element={<ProfilePage />} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
